import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfigService } from 'src/app/services/app-config.service';
import { environment } from 'src/environments/environment';
import { ProfileService } from './profile.service';
import { ImportantAlert } from '../components/important-alerts-widget/models/ImportantAlert';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {


  baseUrl: string = this.appConfig.configuration.environment.endPoints.communicationsServices
  constructor(
    private appConfig: AppConfigService,
    private api: HttpClient,
    private profileService: ProfileService) {

   }
   getAlerts() : Observable<any>{
    let userId = this.profileService.identity.userIdRole
    let path = `${this.baseUrl}/v1/alerts`;
    return this.api.get(path).pipe(map((response)=>response as any));
  }
  dismissAsync(alert: ImportantAlert) {
    let userId = this.profileService.identity.userIdRole
    let path = `${this.baseUrl}/v1/alerts/${alert.id}/dismiss/${userId}`;
    return this.api.post(path,alert).pipe(map((response)=>response as any));
  }
}
